export default "__VITE_ASSET__9IjmThT1__"